import {AppListItem} from '../stores/AppListStore';
import {directoryStore} from '../stores/DirectoryStore';

const PASS_THROUGH_MIN_APPS = ['lytics_audience_sync'];

export const filterAppsByFlags = (apps: AppListItem[]): AppListItem[] => {
  if (directoryStore.isPassThroughAccount()) {
    apps = apps.filter((app) => app.installed || app.metadata?.categories.includes('Audience Sync'));
  }
  if (!directoryStore.isPassThroughMinAccount()) {
    apps = apps.filter((app) => !PASS_THROUGH_MIN_APPS.includes(app.id.app_id));
  }
  return apps;
};
